class ProductPackSelector extends HTMLElement {
  constructor() {
    super();
    this.selectedProducts = new Map();
    this.maxSelection = 0;
    this.initialized = false;
  }

  async connectedCallback() {
    this.maxSelection = Number(this.dataset.selectedMaxSelection) || 0;
    await this.initializeSelection();
  }

  async initializeSelection() {
    if (this.initialized) return;
    
    // Auto-select all visible products
    await this.autoSelectProducts();
    this.updateUI();
    
    const gridWrapper = this.querySelector('.product-grid-wrapper');
    if (gridWrapper) gridWrapper.style.display = 'block';
    
    this.initialized = true;
  }

  setMaxSelection(count) {
    this.maxSelection = count;
    const gridWrapper = this.querySelector('.product-grid-wrapper');
    if (gridWrapper) gridWrapper.style.display = 'block';
  }

  async autoSelectProducts() {
    this.selectedProducts.clear();    
    const cards = this.querySelectorAll('.product-card[data-id]');
    
    cards.forEach((card) => {
      const id = Number(card.dataset.id);
      const price = parseFloat(card.dataset.price);
      
      if (id && !isNaN(price)) {
        this.selectedProducts.set(id, price);
      }
    });
  }

  showLimitMessage(message, type = 'error') {
    const msg = document.querySelector('.pack-limit-msg');
    if (!msg) return;
    
    msg.textContent = message;
    msg.style.color = type === 'error' ? '#e63946' : '#333';
    msg.style.display = 'block';
    msg.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  hideLimitMessage() {
    const msg = document.querySelector('.pack-limit-msg');
    if (msg) msg.style.display = 'none';
  }

  validateSelection() {
    // const selectedCount = this.selectedProducts.size;
    // const min = this.maxSelection;
    // const max = this.maxSelection;

    // if (selectedCount < min) {
    //   this.showLimitMessage(`Please select ${min} products to continue.`, 'error');
    //   return false;
    // }

    // if (selectedCount > max) {
    //   this.showLimitMessage(`You can select a maximum of ${max} products.`, 'error');
    //   return false;
    // }
    this.hideLimitMessage();
    return true;
  }

  updateUI() {
    const cards = this.querySelectorAll('.product-card[data-id]');
    cards.forEach((card) => {
      const id = Number(card.dataset.id);
      // const isSelected = this.selectedProducts.has(id);
      // card.classList.toggle('selected', isSelected);
    });
  }

  getSelectedProducts() {
    return Array.from(this.selectedProducts.keys());
  }

  async reset() {
    this.selectedProducts.clear();
    await this.autoSelectProducts();
    this.updateUI();
  }
}

customElements.define('product-pack-selector', ProductPackSelector);


class PackSelects extends HTMLElement {
  constructor() {
    super();
    this.abortController = null;
    this.handleClick = this.handleClick.bind(this);
  }

  async connectedCallback() {
    this.productUrl = this.dataset.productUrl;
    this.sectionId = this.dataset.section;
    this.changeURL = this.dataset.changeUrl === 'true';
    this.addEventListener('click', this.handleClick);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.handleClick);
    this.abortController?.abort();
  }

  async handleClick(e) {
    const packBtn = e.target.closest('button.pack-btn');
    if (!packBtn || packBtn.disabled) return;

    this.updatePackSelection(packBtn);

    const optionValues = packBtn.dataset.optionValueId;
    if (!optionValues) return;

    const requestUrl = `${this.productUrl}?section_id=${this.sectionId}&option_values=${optionValues}`;
    await this.renderProductInfo(requestUrl);
  }

  updatePackSelection(btn) {
    const allPackBtns = this.querySelectorAll('button.pack-btn');
    allPackBtns.forEach((b) => b.classList.remove('selected'));
    
    btn.classList.add('selected');
    
    // const newMax = Number(btn.dataset.pack);
    
    // if (newMax && !isNaN(newMax)) {
    //   const selector = document.querySelector('product-pack-selector');
    //   if (selector) {
    //     selector.setMaxSelection(newMax);
    //   }
    // }
  }

  async renderProductInfo(requestUrl) {
    this.abortController?.abort();
    this.abortController = new AbortController();

    try {
      const response = await fetch(requestUrl, { signal: this.abortController.signal });
      const responseText = await response.text();
      const html = new DOMParser().parseFromString(responseText, 'text/html');

      if (this.changeURL) {
        const variantData = html.querySelector('pack-selects [data-selected-variant]')?.textContent;
        const variant = variantData ? JSON.parse(variantData) : null;
        const newUrl = `${this.productUrl}${variant ? `?variant=${variant.id}` : ''}`;
        window.history.replaceState({}, '', newUrl);
      }
      
      await this.updateSourceFromDestination(['set-image', 'selected-variant-image', 'product-grid'], this.sectionId, html);
      
      // Auto-select products after DOM update
      const selector = document.querySelector('product-pack-selector');
      if (selector) {
        await selector.autoSelectProducts();
        selector.updateUI();
      }

    } catch (error) {
      if (error.name !== 'AbortError') {
        console.log('Error fetching product info:', error);
      }
    }
  }

  async updateSourceFromDestination(selectors, sectionId, html) {
    selectors.forEach((selector) => {
      const destination = document.querySelector(`[data-${selector}-${sectionId}]`);
      const source = html.querySelector(`[data-${selector}-${sectionId}]`);
      if (destination && source) {
        destination.innerHTML = source.innerHTML;
      }
    });
        
    document.dispatchEvent(new CustomEvent('bls:product:media:updated'));
  }

}

customElements.define('pack-selects', PackSelects);